import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const getEligibilityCriteria = async () => {
  try {
    const apiLink = `${endpoint}/api/partner/get-eligibility-criteria`;
    const response = await axios.get(apiLink);
    return response.data;
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default getEligibilityCriteria;
